const allModules = ['label', 'shipment', 'offerAndTask', 'oversea', 'forecast', 'margin', 'monthlyFee', 'monthEndClose', 'announcement']

// split labelAndOrder to label and shipment
// if both available, show order module and warehouse related
// categorize the inbound and outbound to shipment now
// we can add more moduleName to micromize the ui display
// viteusa used as a default env
const thirdPartModuleConfig = {
  viteusa: ['label', 'shipment', 'offerAndTask', 'oversea', 'forecast', 'monthlyFee', 'monthEndClose', 'announcement'],
  far800: ['label', 'oversea', 'announcement'],
  fsd915: ['label', 'oversea'],
  eagle: ['label', 'margin']
}

module.exports = {
  allModules,
  thirdPartModuleConfig
}


//////////////////
// WEBPACK FOOTER
// ./config/moduleConfig.js
// module id = CV0m
// module chunks = 21